import Vue from "vue";
import methods from './global-methods';

// components
import DatePicker from '../components/shared/DatePicker.vue'
import Pagination from "../components/shared/Pagination";
import Modal from "../components/shared/Modal";
import AlertComponent from "../components/shared/AlertComponent";
import AddressModal from "../components/shared/AddressModal";
import ActionsComponent from "../components/shared/ActionsComponent";

const globalMethods = methods;

Vue.mixin({
    components: {
        DatePicker,
        Pagination,
        Modal,
        AlertComponent,
        AddressModal,
        ActionsComponent,

    },
    data() {
        return {
            RESOURCE_EKYZMAT_ID: 1,
            RESOURCE_LOCAL_POSITIONS_ID: 2,
            RESOURCE_NRK_ID: 3,
            RESOURCE_CATEGORIES_ID: 4,
            RESOURCE_REGISTER_POST_ID: 13,
            RESOURCE_MRK_ID: 14,
            RESOURCE_DEMO_ID: 18,

            QUESTION_SINGLE: 1,// Один правильный ответ
            QUESTION_MULTIPLE: 2,// Несколько правильных ответов
            QUESTION_CONFIRMITY: 3, // Установление соответствия
            QUESTION_SEQUENCE_CORRECT: 4,// Правильный последовательность
            QUESTION_FILL_IN: 5,// Заполнение

            APP_TYPE_POSITION_ATTESTATION: 7,
            APP_TYPE_ATTESTATION: 3,
            APP_TYPE_RRK: 4,
            APP_TYPE_DEMO: 8,
            APP_TYPE_NRK: 2,
            APP_TYPE_EKYZMAT: 1,

            TEST_TYPE_MAIN: 2,
            TEST_TYPE_LAW: 1,

            ANSWER_SETTINGS_ID: 1,
            QUESTION_LIST_SETTINGS_ID: 2,

            QUESTION_SETTINGS_BY_ONE: 1,
            QUESTION_SETTINGS_ALL: 2,
        }
    },
    methods: globalMethods,
    computed: {
        currentLocale() {
            return this.$store.getters['language/getCurrentLocale'];
        },
        testingLocale() {
            return this.$store.getters['language/getTestingLanguage'];
        },
        translations() {
            return this.$store.getters['language/getTranslations'];
        }
    }
});

export default methods;
